<template>
  <div class="commitment-wrap">
    <div class="nav-wrap">
      <div class="flex">
        <i class="iconfont icon-home1"></i>
        <router-link class="link" to="publicity/main">信用公示</router-link>
        <i class="el-icon-arrow-right"></i>
        <router-link class="link" to="/promise" replace
          ><span>信用承诺</span></router-link
        >
      </div>
    </div>
    <div class="commitment-bottom">
      <div class="wrap-border flex commitment-tab">
        <div
          class=""
          v-for="item in tabList"
          :key="item.id"
          :class="{ active: item.enCode === tabId }"
          @click="tabHandler(item)"
        >
          {{ item.fullName }}
        </div>
      </div>
      <div class="wrap-border commitment-search">
        <!--				<router-link to="createPromise" target="_blank" class="commitment-btn">信用承诺申报</router-link>-->
        <el-form ref="form" :model="formData" label-width="140px">
          <el-form-item label="主体名称" prop="realname">
            <el-input
              v-model="formData.realname"
              placeholder="请输入企业名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="number">
            <el-input
              v-model="formData.number"
              placeholder="请输入统一代码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            prop="imageCaptcha"
            :rules="[{ required: true, message: '请输入验证码' }]"
          >
            <el-input
              v-model="formData.imageCaptcha"
              placeholder="输入验证码"
            ></el-input>
            <el-image
              :src="imageCode"
              @click="getCaptchaImgHandle"
              style="width: 80px; height: 40px; cursor: pointer"
              fit="fit"
            ></el-image>
          </el-form-item>
          <div class="flex flex-row-center commitment-buttons">
            <el-button type="primary" @click="resetHandle">重置</el-button>
            <el-button type="primary" @click="confirmHandle">查询</el-button>
          </div>
        </el-form>
      </div>
      <div class="wrap-border">
        <div class="commitment-title">
          <i class="iconfont icon-rizhi"></i>查询结果
        </div>
        <empty v-if="!list.length" />
        <ul class="commitment-table" v-else>
          <li class="flex commitment-header">
            <p>序号</p>
            <p>承诺人名称</p>
            <p>统一社会信用代码</p>
            <p>法人承诺类型</p>
            <p>承诺时间</p>
            <p>承诺有效期</p>
            <p>承诺事项</p>
            <p>履行状态</p>
            <p>操作</p>
          </li>
          <li class="flex" v-for="(item, index) in list" :key="item.id">
            <p class="ellipsis-1">{{ index + 1 }}</p>
            <p class="ellipsis-1">{{ item.cnrmc }}</p>
            <p class="ellipsis-1">{{ item.cnrdm }}</p>
            <p class="ellipsis-1">{{ item.cnlx }}</p>
            <p class="ellipsis-1">{{ item.cnzcrq }}</p>
            <p class="ellipsis-1">{{ item.cnyxq }}</p>
            <p class="ellipsis-1">{{ item.cnnr }}</p>
            <p class="ellipsis-1">{{ item.cnlxzt }}</p>

            <p>
              <router-link
                tag="a"
                target="_blank"
                style="color: #d01c0b"
                :to="`/promiseDetail?detailInfo=${JSON.stringify(item)}`"
                >查看详情</router-link
              >
            </p>
          </li>
        </ul>
        <div class="flex flex-row-end page-wrap" v-if="list.length > 0">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :pageSize="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, promiseList, promiseMatters } from '@/api'
import { v4 as uuidv4 } from 'uuid'
import BASE_URL from '@/api/base.js'
import empty from '@/components/empty'
export default {
  components: {
    empty,
  },
  data() {
    return {
      tabList: [],
      tabId: undefined,
      formData: {},
      list: [{}],
      pageSize: 15,
      total: 0,
      imageCode: undefined,
      uuid: undefined,
    }
  },
  created() {},
  mounted() {
    this.getCaptchaImgHandle()
    this.getList()
  },
  methods: {
    getCode(code) {
      let tabList = getCode({ code })
      return tabList
    },
    async getTabList() {
      if (this.tabList.length === 0) {
        const tabList = await this.getCode('promiseMatter')
        this.$set(this, 'tabList', tabList)
        this.$set(this, 'tabId', tabList[0].enCode)
      }
    },

    tabHandler(row) {
      const { enCode } = row
      const { imageCaptcha } = this.formData
      if (imageCaptcha) {
        this.getCaptchaImgHandle()
        this.$set(this.formData, 'imageCaptcha', undefined)
      }
      if (enCode !== this.tabId) {
        this.$set(this, 'tabId', enCode)
        this.getList(1)
      }
    },
    getCaptchaImgHandle() {
      let uuid = uuidv4()
      this.uuid = uuid
      this.imageCode = BASE_URL + `/api/captcha/image?token=${this.uuid}`
    },
    async getList(page = 1) {
      await this.getTabList()

      const params = {
        current: page,
        category: this.tabId,
      }
      const { realname, number, imageCaptcha } = this.formData
      if (imageCaptcha) {
        params.imageCaptcha = imageCaptcha
        params.imageToken = this.uuid
        if (realname) {
          params.realname = realname
        }
        if (number) {
          params.number = number
        }
      }

      promiseList(params).then((res) => {
        console.log(res)
        this.setResponse(res)
      })
    },
    handleCurrentChange(e) {
      this.getList(e)
    },
    setResponse(response) {
      console.log(response)
      const { size, records, total } = response
      console.log(response)
      this.$set(this, 'list', records)
      this.$set(this, 'total', total)
      this.$set(this, 'pageSize', size)
    },
    resetHandle() {
      this.$refs['form'].resetFields()
      this.$set(this, 'formData', {})
    },

    confirmHandle() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.getList(1)
        }
      })
    },
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss">
.commitment-wrap {
  .commitment-bottom {
    width: 1280px;
    margin: 0 auto;
    padding: 20px 0;
    & > .commitment-tab {
      border-bottom: 5px solid #dfe8ef;
      & > div {
        height: 50px;
        text-align: center;
        font-size: 18px;
        color: #212121;
        line-height: 50px;
        border-bottom: 5px solid transparent;
        padding: 0 15px;
        cursor: pointer;
        margin-bottom: -5px;
        &.active {
          color: $red;
          border-color: $red;
        }
      }
    }
    & > .commitment-search {
      margin-bottom: 20px;
      padding: 30px 0 20px;
      position: relative;
      .commitment-btn {
        border-radius: 6px;
        width: 150px;
        line-height: 40px;
        background-color: $red;
        color: #fff;
        position: absolute;
        top: 20px;
        right: 20px;
        text-align: center;
      }
      .el-form {
        width: 430px;
        margin: 0 auto;
      }
      .el-form-item {
        position: relative;
        .el-image {
          position: absolute;
          right: -85px;
          bottom: 10px;
        }
      }
      .el-input {
        width: 280px;
        .el-input__inner {
          width: 278px;
          height: 40px;
          border-color: #ccc;
          border-radius: 1px;
        }
      }
      .commitment-buttons {
        margin: 0 auto;
        width: 100%;
        .el-button {
          background-color: $red;
          border-color: $red;
          width: 150px;
          margin: 0 30px;
          &:first-of-type {
            background-color: #eee;
            border-color: #eee;
            color: #212121;
          }
        }
      }
    }

    .commitment-table {
      width: 1120px;
      margin: 20px auto 0;
      & > .commitment-header {
        background-color: #f4f4f4;
      }
      & > li {
        height: 40px;
        text-align: center;
        & > p {
          width: 100px;
          flex-shrink: 0;
          &:first-of-type {
            width: 80px;
          }
          &:nth-child(2) {
            flex-grow: 2;
          }
          &:nth-child(3) {
            width: 150px;
          }
        }
        &:nth-child(even) {
          background-color: #fbfbfb;
        }
      }
    }
    .page-wrap {
      margin: 20px auto;
      width: 1120px;
    }

    .commitment-title {
      text-align: left;
      width: 1120px;
      margin: 10px auto;
      font-weight: 600;
      counter-reset: #212121;
      vertical-align: baseline;
      i {
        font-size: 20px;
        color: $red;
        margin-right: 5px;
      }
    }
  }
}
</style>
